import { Application } from "@hotwired/stimulus"
import Carousel from '@stimulus-components/carousel'
import Dropdown from '@stimulus-components/dropdown'
import Dialog from '@stimulus-components/dialog'
import ScrollReveal from '@stimulus-components/scroll-reveal'


const application = Application.start()
application.register('carousel', Carousel)
application.register('dropdown', Dropdown)
application.register('dialog', Dialog)
application.register('scroll-reveal', ScrollReveal)

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }
